import { useState, useEffect } from "react";
import { usePlans } from "../hooks/usePlans";
import type Plan from "../models/Plan";
import { PlanesSidebar } from "../components/planes_sidebar";
import { PlansTable } from "../components/plans_table";
import GlassContainer from "@/shared/components/glasscontainer";
import { confirmDialog } from "@/shared/components/dialog";
import GlassBackground from "@/shared/components/glassBackground";

const TABS = ["Configuración de tarifas"];

export default function PlaneManagementPage() {
  const [tab, setTab] = useState(0);
  const [plans, setPlans] = useState<Plan[]>([]);
  const { loading, error, getAllPlans, deletePlan } = usePlans();

  useEffect(() => {
    let ignore = false;
    const fetchPlans = async () => {
      const page = await getAllPlans({ pageNumber: 1, pageSize: 100 });
      if (!ignore && page) setPlans(page.items);
    };
    fetchPlans();
    return () => { ignore = true; };
  }, [getAllPlans]);

  const handleDelete = async (id: string) => {
    const confirmed = await confirmDialog({
      title: "Eliminar plan",
      message: "¿Estás seguro de que deseas eliminar este plan? Esta acción no se puede deshacer.",
      confirmLabel: "Sí, eliminar",
      cancelLabel: "Cancelar",
      variant: "danger",
    });
    if (!confirmed) return;
    try {
      await deletePlan(id);
      setPlans((prev) => prev.filter((p) => p.id !== id));
    } catch {
      // error toast handled by useAsync
    }
  };

  return (
    <GlassBackground>
      <div className="relative flex w-full overflow-hidden">
        <PlanesSidebar totalPlans={plans.length} loading={loading} />

        <main className="flex-1 overflow-auto p-8">
          {/* Header */}
          <div className="mb-8">
            <h2 className="text-[40px] font-bold tracking-tight text-foreground">
              Planes
            </h2>
            <p className="text-foreground/50 text-lg font-medium mt-1">
              Configura y gestiona las tarifas de suscripción.
            </p>
          </div>

          {/* Tabs */}
          <GlassContainer className="flex gap-2 mb-6 p-1 w-fit ">
            {TABS.map((t, i) => (
              <button
                key={t}
                onClick={() => setTab(i)}
                className={`px-5 py-2.5 rounded-xl text-sm font-semibold transition-all cursor-pointer ${tab === i
                  ? "bg-white text-accent shadow-md"
                  : "text-foreground/50 hover:text-foreground hover:bg-white/40"
                  }`}
              >
                {t}
              </button>
            ))}
          </GlassContainer>

          <PlansTable
            plans={plans}
            loading={loading}
            error={error}
            onDelete={handleDelete}
          />

          {/* <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <AdditionalSettings settings={additionalSettings} />
            <AlertCard />
          </div> */}
        </main>
      </div>
    </GlassBackground>
  );
}
